export const stripBuildInformation = (a: string): string => {
  if (typeof a !== 'string') {
    return a;
  }
  return a.replace(/-.*/, '').replace(/\.[^.]*[^0-9. ][^.]*$/, '');
};

export const trimVersion = (v: string): string => {
  return v.replace(/-.*/, '').split('.').splice(0, 3).join('.');
};

export interface CheckVersionArgs {
  min: string;
  version: string;
}

export const checkVersionGE = ({ version, min }: CheckVersionArgs): boolean => {
  const result = compareVersion(version, min);
  return typeof result === 'boolean' ? result : result !== -1;
};

export const isVersionString = (version?: string): boolean => {
  return typeof version === 'string' && !!version.match(/^[0-9. ]+$/);
};

export const compareVersion = (a: string, b: string): 1 | 0 | -1 | false => {
  a = stripBuildInformation(a);
  b = stripBuildInformation(b);
  if (!isVersionString(a) || !isVersionString(b)) {
    return false;
  }
  const aParts = a.split('.'); // should have three.
  const bParts = b.split('.'); // should have up to three

  // Make sure they are the same length.
  padRight(aParts, bParts.length, '0');
  padRight(bParts, aParts.length, '0');
  const len = aParts.length;
  for (let i = 0; i < len; ++i) {
    const value = checkStringVersion(aParts[i], bParts[i]);
    if (value !== 0) {
      return value;
    }
  }
  return 0;
};

const padRight = (arr: string[], max: number, value: string): void => {
  while (arr.length < max) {
    arr.push(value);
  }
};

export const checkStringVersion = (lt: string, rt: string): -1 | 0 | 1 => {
  const a = parseInt(lt.trim(), 10);
  const b = parseInt(rt.trim(), 10);
  return a < b ? -1 : a > b ? 1 : 0;
};
